import { useEffect, useState } from 'react';

/** Returns the id of the section currently crossing the middle of the viewport. */
const useActiveSection = (ids) => {
  const [active, setActive] = useState('');

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );
    ids.forEach((id) => {
      const node = document.getElementById(id);
      if (node) observer.observe(node);
    });
    return () => observer.disconnect();
    // ids is a stable module-level list
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return active;
};

export default useActiveSection;
